import React, { useState } from 'react'
import styles from './RowCourseLevel.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import { ReactComponent as OpenClient } from 'components/CRM/UI/icons/arrow-down-s-line.svg'

const RowCourseLevel = ({ level, index, action, key }) => {
  const [expanded, setExpanded] = useState(false)

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  const menu = [
    { name: 'Edit', action: 'edit' },
    { name: 'Delete', action: 'delete' },
  ]

  return (
    <>
      <div
        className={`${styles.clientContainer} ${index % 2 === 0 ? styles.colorBg : ''} ${expanded && styles.colorBgActive}`}
      >
        <div className={styles.containerInf}>
          <div
            className={`${styles.infStyl} ${styles.name} ${expanded ? styles.expClr : styles.notExpClr}`}
          >
            {level.name}
          </div>
          <div className={styles.buttons}>
            <div
              className={`${styles.buttonClient} ${expanded ? styles.rotate : ''}`}
              onClick={toggleExpand}
            >
              <OpenClient className={styles.btnArrow} />
            </div>
            <ActionMenu menu={menu} action={action} items={level} />
          </div>
        </div>
      </div>
      {expanded && (
        <div className={styles.clientDetails}>
          <div className={`${styles.formField} `}>
            <div className={styles.label}>Course level:</div>
            <div className={styles.info}>{level.name}</div>
          </div>
        </div>
      )}
    </>
  )
}

export default RowCourseLevel
